// @ts-nocheck
export const capitalizeFirstLetter = string =>
  string ? string[0].toUpperCase() + string.slice(1) : ""
